import { Fragment, useEffect, useRef, useMemo, useState } from 'react'
import { useTranslation } from "react-i18next";
import download from 'downloadjs';
// import axios from 'axios';
import numeral from 'numeral';

import Backdrop from '../Backdrop/Backdrop';
import Loader from '../Loader/Loader';
import Modal from '../Modal/Modal.jsx';
import UploadedFileUseContent from '../UploadedFileUseContent/UploadedFileUseContent.jsx';
// import VideoToAudioFileUpload from './FileUpload/VideoToAudioFileUpload';
import VideoToMp4Action from './VideoToMp4Action.jsx';
import VideoToMp4FileUpload from './FileUpload/VideoToMp4FileUpload.jsx';
import VideoToAudioAbout from './VideoToAudioAbout.jsx';
import VideoToAudioSocket from './VideoToAudioSocket.jsx';
import GetUsageBasedSubscription from '../UsageBasedBilling/GetUsageBasedSubscription.jsx';
// import AuthButtons from "../UI/AuthButtons.jsx";


import { useStore } from '../../hook-store/store';
import { convert } from '../../utils/video-to-audio-utils/video-to-audio-utils';
import { uploadLargeFileForProcess } from '../../utils/large-file-upload-utils/large-file-upload-utils.js';
import { marks } from '../../utils/marks';

import { TEXTAUDIOTOOLSNODE_URL } from '../../App.js';

import './VideoToAudio.css';



function VideoToMp4(props) {
  const {
    videoToAudioConfig
  } = props;

  const [t] = useTranslation("translation");

  const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    isAuth,
    paramFileData,
    paramFileDataList,
   } = store.uiStore;
  const { 
      usageBasedConfig,
      usageBasedSubscription,
      usageBasedValidMethod,
      usageBasedPrice,
  } = store.stripeData;
  // const { mlSpeechText } = store.mlSpeechStore;

  // console.log('store-answer-finder', store)
  

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [displayVideo, setDisplayVideo] = useState();
  const [showModalUseUploaded, setShowModalUseUploaded] = useState(false);
  const [showPageAbout, setShowPageAbout] = useState(false);
  
  const [selectedVideoFile, setSelectedVideoFile] = useState();
  const [selectedVideoDuration, setSelectedVideoDuration] = useState();
  const [convertedVideoFile, setConvertedVideoFile] = useState();
  // const [uploadFileType, setUploadFileType] = useState('converted');
  const [isLoading, setIsLoading] = useState(false);

  const uploadApp = 'videoToMp4';
  // const CHUNK_SIZE = 1024 * 1024 * 1; // 5MB per chunk


  useEffect(() => {
    window.scrollTo(0,0);
  },[]);
  
  //// clear notification when leave app
  useEffect(() => {
    return () => {
      dispatch('CLEAR_NOTIFICATION');
    }
  },[]);

  useEffect(() => {
    if (!selectedVideoFile && paramFileDataList && paramFileDataList.files?.length > 0 &&
          paramFileDataList.openApp === 'videoToMp4'
    ) {
      // setSelectedVideoFile(paramFileDataList.files[0]);
      selectVideoHandler(paramFileDataList.files);
      dispatch('SET_PARAMFILEDATALIST', null);
    }

  },[paramFileDataList]);

  console.log('selectedVidoeFile', selectedVideoFile);
  // //// convert paramFile
  // useEffect(() => {
  //   if (paramFileData && paramFileData.file && paramFileData.openApp === 'videoToAudio') {
  //     convertToAudio(null, paramFileData.file);
  //     // selectCombinerFilesHandler(paramFileDataList.files);
  //     dispatch('SET_PARAMFILEDATA', null);
  //   }

  // },[paramFileData]);
  

  const handleInputClick = (event) => {
    hiddenFileSelect.current.click()
  }

  const selectVideoHandler = (videoFiles) => {
    // const files = event.target.files;
    
    // if (event) {
      //   files = event.target.files;
      // }
      
    let files;
    
    if (videoFiles) {
      files = videoFiles;
    }

    if (!files) {
      return;
    }

    if (files && files.length > 0) {
      
      const mimeType = files[0].type;
      // console.log('mimeType', mimeType, files[0]);
      if (!mimeType || mimeType.split('/')[0] !== 'video' || 
          mimeType.split('/')[1] === 'mp4'
      ) {
        alert('invalid file is selected')
      } else {
        setSelectedVideoFile(files[0]);

        updateVideoDureationHandler(files[0]);
      }
    }
  };

  const updateVideoDureationHandler = (file) => {
      // Create a temporary local URL for the file object
      const fileUrl = URL.createObjectURL(file);

      // Create an invisible HTML5 video element
      const video = document.createElement("video");
      video.preload = "metadata"; // Instructs the browser to only fetch metadata

      // Wait until metadata is ready to read the duration safely
      video.onloadedmetadata = () => {
        // console.log('video', video);
        setSelectedVideoDuration(video.duration); // Duration is provided in seconds
        URL.revokeObjectURL(fileUrl); // Clean up memory immediately
      };

      video.src = fileUrl;
  };

  const convertedVideoDownload = (file) => {
    download(file, file.name, file.type);
  };


  // async function convertVideoToMp4(url, token, files) {
  //   try {
  //     dispatch('CLEAR_NOTIFICATION');
  //     setIsLoading(true);
      
  //     const data = new FormData(); 

  //     // console.log(selectedFiles);
  //     for (const file of files) {
  //       data.append('files', file);
  //     }

  //     if (localStorage.getItem('customerId')) {
  //       data.append('customerId', localStorage.getItem('customerId'));
  //     }
      
  //     // if (uploadApp) {
  //     //   data.append('uploadApp', uploadApp);
  //     // }

  //     // console.log('data', data, data.getAll('files'));
  //     const headers = {
  //       // 'Content-Type': 'application/json',
  //       'Authorization': 'Bearer ' + token,
  //     };
    

  //     // const response = await axios.request({
  //     //   method: 'post',
  //     //   url: url + "/video-to-audio/video-file-to-mp4-file",
  //     //   data: data,
  //     //   headers: headers,
  //     //   responseType: 'blob', // CRITICAL: Tells Axios to handle binary data
  //     //   onUploadProgress: (p) => {
  //     //     // console.log('onUploadProgress', (p.loaded/p.total*100).toFixed(0), p); 

  //     //     let message = `Uploading... ${(p.loaded/p.total*100).toFixed(0)}%`;

  //     //     if (p.loaded/p.total === 1) {
  //     //       message = 'Uploaded, file conversion started...'
  //     //     }

  //     //     dispatch('SHOW_NOTIFICATION', {
  //     //       status: '',
  //     //       title: message,
  //     //       message: '',
  //     //     });
  //     //   }
  //     // });

  //     // console.log(response, response.data);

  //     // if (response.status !== 200) {
  //     //   throw new Error('error occured');
  //     // }

  //     // const blob = response.data;

  //     dispatch('SHOW_NOTIFICATION', {
  //       status: '',
  //       title: `file upload starting...`,
  //       message: '',
  //     });

  //     const result = await fetch(url + `/video-to-audio/video-file-to-mp4-file`, {
  //       method: 'POST',
  //       headers: {
  //         // 'Content-Type': 'application/json',
  //         Authorization: 'Bearer ' + token,
  //         // responseType: 'blob',
  //       },
  //       body: data,
  //     });

      
  //     if (result.status !== 200) {
  //       throw new Error('error occured');
  //     }
      
  //     const blob = await result.blob();
  //     console.log(result, blob);

  //     const file = new File([blob], `converted-${Date.now()}.mp4`, {
  //       type: 'video/mp4'
  //     });

  //     if (file) {
  //       setConvertedVideoFile(file);
  //     }
      
  //     setIsLoading(false);

  //     dispatch('SHOW_NOTIFICATION', {
  //       status: '',
  //       title: 'mp4 video file created',
  //       message: '',
  //     });

  //     // setTimeout(() => {
  //     //   dispatch('CLEAR_NOTIFICATION');
  //     // },1000 * 5);

  //   } catch(err) {
  //     console.log(err);
  //     setIsLoading(false);

  //     dispatch('SHOW_NOTIFICATION', {
  //       status: 'error',
  //       title: 'file conversion failed',
  //       message: '',
  //     });
  //   }
  // };


const convertVideoToMp4V2 = async (url, path, token, uploadFile, chunkSize) => {
    try {
      setIsLoading(true);

      let priceId;

      if (usageBasedPrice) {
        priceId = usageBasedPrice.id;
      }

      const response = await uploadLargeFileForProcess(
        TEXTAUDIOTOOLSNODE_URL,
        `/video-to-audio/video-file-to-mp4-file2`,
        localStorage.getItem('token'),
        uploadFile,
        chunkSize,
        localStorage.getItem('customerId'),
        priceId,
      );

      console.log(response);

      if (!response.ok) {
        throw new Error('error occured');
      }

      const blob = await response.blob();
      

      const file = new File([blob], `converted-${Date.now()}.mp4`, {
        type: 'video/mp4'
      });

      if (file) {
        setConvertedVideoFile(file);
      }
      
      // setIsLoading(false);

      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: 'mp4 video file created',
        message: '',
      });

      // setTimeout(() => {
      //   dispatch('CLEAR_NOTIFICATION');
      // },1000 * 5);


      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);

      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: 'file conversion failed',
        message: '',
      });
    }
  };


  const createDisplayVideo = () => {
    setDisplayVideo(
      <div>
        <div>
          {t('videoToAudio07', 'Converted video')} 
        </div>
        <div className='videoToAudioSection'>
          <video className='videoToAudioAudio'
            src={URL.createObjectURL(convertedVideoFile)}
            controls
          />
        </div>
        <div className='videoToAudioSection'>
          <div className='videoToAudioButtons'>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { 
                convertedVideoDownload(convertedVideoFile); 
              }}
            >
              {marks.downloadMark} {t('videoToAudio08', 'Download video file')} 
            </button>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => { 
                setShowUploadModal(true);
                // setUploadFileType('converted');
              }}
            >
              {marks.uploadMark} {t('videoToAudio09', 'Upload video file')} 
            </button>
            {/* <button className='btnBase'
              disabled={isLoading}
              onClick={() => { 
                setShowUploadModal(true);
                setUploadFileType('input');
              }}
            >
              {marks.uploadMark} upload-input-file
            </button> */}
          </div>
        </div>
      </div>
    );
  }


  const expensiveValue = useMemo(() => {
    // console.log('Computing expensive value...');
    if (convertedVideoFile) {
      createDisplayVideo();
    }
  }, [convertedVideoFile]);



  // let isActionButtonDisabled = true;
  // // let uploadFile;

  // if (isAuth && selectedVideoFile) {
  //   isActionButtonDisabled = false;
  // }

  // if (uploadFileType === 'converted') {
  //   uploadFile = convertedVideoFile;
  // };

  // if (uploadFileType === 'input') {
  //   uploadFile = selectedVideoFile;
  // };




  // let bannerElement;

  // if (window.innerWidth <= 450) {
  //   bannerElement = (
  //     <iframe id="kura-text-audio-tools.spaceeight.net-1725583665876"
  //         style={{width:"310px", height:"70px", border:"none"}}  
  //         src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583665876"
  //     />
  //   );
  // }

  // if (window.innerWidth > 450 && window.innerWidth <= 768) {
  //   bannerElement = (
  //     <iframe id="kura-text-audio-tools.spaceeight.net-1725583679744"
  //     style={{width:"460px", height:"95px", border:"none"}}  
  //     src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583679744"
  //     />
  //   )
  // }

  // if (window.innerWidth > 768) {
  //   bannerElement = (
  //     <iframe id="kura-text-audio-tools.spaceeight.net-1725583699146"
  //         style={{width:"610px", height:"135px", border:"none"}}  
  //         src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583699146"
  //     />
  //   );
  // }

  return (
    <Fragment>

      <div className='videoToAudio'>
        {/* <div 
          style={{
              display: 'flex',
              justifyContent: "center",
              paddingTop: "1rem",
              paddingBottom: "2rem"
          }}
          >
            {bannerElement}
        </div> */}

      <div className='videoToAudioSection'>
        <div className='videoToAudioTitle'>
          <span>
            Convert to MP4
          </span>
          {' '}
          <span className="transcribeAudioTitleMark"
              onClick={() => {
                  setShowPageAbout(!showPageAbout);
              }}
          >
              {marks.questionCircleOMark}
          </span>
        </div>
        {showPageAbout && (
            <div className="videoToAudioAbout">
                <VideoToAudioAbout />
            </div>
        )}
      </div>

      <div className='videoToAudioSection'>
        <div className='videoToAudioButtons'>
          <input 
            type='file' 
            accept=".webm, .mov, .avi, "
            // accept="video/mp4, video/x-msvideo, video/webm, .mov"
            // accept="video/*"
            ref={hiddenFileSelect}
            style={{display:"none"}}
            onChange={(event) => {
              selectVideoHandler(event.target.files)
              // convertToAudio(event); 
            }} 
          />
          <button className="btnBase"
            // style={ipaImages.length === 0 ? {display: "block"} : {display: "none"}} 
            disabled={isLoading} 
            onClick={handleInputClick}
          >
            {marks.fileVideoOMark}{' '}
            {t('videoToAudio01', 'Select video file')} (webm, mov, avi)
          </button>

          <button className="btnBase"
            style={{border:"0.5px solid gray", borderRadius: "4px"}}
            // disabled={isLoading} 
            onClick={() => { 
              setShowModalUseUploaded(true); 
            }}
          >
            {marks.downloadMark}{' '}
            {t('audioEditor03', 'Uploaded file')} 
          </button>
        </div>
      </div>

      {selectedVideoFile && (
        <div>
          <div className='videoToAudioSection'>
            <div>
              {t('videoToAudio06', 'Selected file')} 
            </div>
            <div>
              <strong>
                {selectedVideoFile.name}
              </strong>
              <span>{' '}(
                {numeral(selectedVideoFile.size).format('0.0 b')}
                {/* {', '}{selectedVideoDuration.toFixed(0)} second */}
              )</span>
              {/* {selectedVideoDuration && (
                <span>{' '}(
                  {numeral(selectedVideoFile.size).format('0.0 b')}
                  )</span>
              )} */}
            </div>
          </div>

          <VideoToMp4Action 
            videoToAudioConfig={videoToAudioConfig}
            selectedVideoFile={selectedVideoFile}
            // selectedVideoDuration={selectedVideoDuration}
            setConvertedVideoFile={setConvertedVideoFile}
            uploadApp={uploadApp}
          />
          
          {/* {!isAuth && (
            <div>
              <div className='videoToAudioSection'>
                Login is required.
              </div>
              <div className='videoToAudioSection'>
                <AuthButtons />
              </div>
            </div>
          )} */}
        </div>
      )}
      {/* {isLoading && (
        <div>
          <Backdrop 
          zIndex={'95'}
          onCancel={() => { 
            setShowUploadModal(false);
          }}
          />
          <Loader />
          </div>
      )} */}

      <div className='videoToAudioSection'>
        {displayVideo}
      </div>

      {showUploadModal && (
        <div>
          <VideoToMp4FileUpload 
            uploadFiles={[convertedVideoFile]}
            // uploadFiles={[uploadFile]}
            setShowUploadModal={setShowUploadModal}
            uploadApp={uploadApp}
          />
        </div>
      )}

      {showModalUseUploaded && (
          <div>
            <Backdrop 
              zIndex={'95'}
              onCancel={() => { 
                setShowModalUseUploaded(false);
              }}
            />
            <Modal
              onClose={() => {
                setShowModalUseUploaded(false);
              }}
            >
              <UploadedFileUseContent
                setShowModalUseUploaded={setShowModalUseUploaded}
              />
            </Modal>
          </div>
        )}

        {!usageBasedPrice && (
          <GetUsageBasedSubscription />
        )}

        <VideoToAudioSocket 
          uploadApp={uploadApp}
        />
    </div>
    </Fragment>
  )
}

export default VideoToMp4;